import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {GroupCelebration} from "@irati/types"
import ScheduledGroupCelebrationFragment from "../../services/fragments/ScheduledGroupCelebration"

const query = gql`
  query GroupCelebration($id: String!) {
    groupCelebration(id: $id) {
      ...ScheduledGroupCelebration
    }
  }

  ${ScheduledGroupCelebrationFragment}
`
export interface GroupRecognitionData {
  data?: {
    groupCelebration: GroupCelebration
  }
}
export const groupCelebrationQuery = {
  query
}
export const groupCelebrationQueryKey = getQueryNames(query)[0]
export default query
